// extracted by mini-css-extract-plugin
module.exports = {"test":"Test_test__xZ63H","top":"Test_top__1OThW","testContainer":"Test_testContainer__3H7Bp"};